import Height from "./Height";
import Weight from "./Weight";
import BaseQuestionnaireFormData from "../BaseQuestionnaireFormData";
import {
    ACTIVITY_LEVEL,
    ALLERGY,
    DIETARY_PREFERENCE, FOOD_DISLIKE_EAT, FOOD_OFTEN_EAT,
    HEALTH_CONCERNS,
    MEAL_COUNT,
    RESULTS_TIMING
} from "../../../const/WeightLossQuestionnaire";

const WEIGHT_LOSS_QUESTIONNAIRE_CONSTANTS = {
    ACTIVITY_LEVEL,
    ALLERGY,
    DIETARY_PREFERENCE,
    FOOD_DISLIKE_EAT,
    FOOD_OFTEN_EAT,
    HEALTH_CONCERNS,
    MEAL_COUNT,
    RESULTS_TIMING
};

export class WeightLossFormData extends BaseQuestionnaireFormData {
    constructor() {
        super({
            HeightModel: Height,
            WeightModel: Weight,
            questionnaireConstants: WEIGHT_LOSS_QUESTIONNAIRE_CONSTANTS,
            mainGoal: "weight_loss",
            mainGoalCode: 0,
            mainGoalLokalise: "Lose weight",
            workoutName: "weight-loss",
            mode: "weightloss"
        });
    }
}

export default WeightLossFormData;
